import { vuexfireMutations, firestoreAction } from 'vuexfire'
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import plans from '@/plans'

const actions = {
    addUserToOrganization(_, {userId, userEmail}){
        const member = {
            email: userEmail,
            permission: "editor",
            signup: false
        }
        return firebase.firestore().collection('users').where("members", "array-contains", member).get().then( function(querySnapshot) {
            return querySnapshot.forEach( function(doc) {
                console.log("addUserToOrganization")
                console.log(doc.id)
                let data = doc.data()
                let organizationId = doc.id
                let plan = data.plan
                console.log(data)
                console.log(plan)


                return firebase.firestore().collection(`users`).doc(userId).update({
                    organization: data.organization,
                    organizationId: organizationId,
                    plan: plan
                })
            })
        })
    },
    updateUser(_, { userId, update }) {
        firebase.firestore().doc(`users/${userId}`).set(update, {merge:true})
    },
    updatePayments(_, { userId, update }) {
        firebase.firestore().doc(`users/${userId}`).set(update, {merge:true})
    },
    updateModelPredictionsTotal(_, { userId, update }) {
        firebase.firestore().doc(`users/${userId}`).update(update)
    },
    sendEmailNotificationAdmin(_, {title, data}) {

        firebase.firestore().collection(`emails`).add({
          "to": ["sales@metatext.io"],
          "message": {
            "subject": title,
            "html": `Hi<br><br>${title}: ${JSON.stringify(data)}<br><br>`
          }
        })
    },
    sendContactForm(_, contactForm) {

        firebase.firestore().collection(`emails`).add({
          "to": ["hi@metatext.io", "rafaelsandronidias@gmail.com"],
          "message": {
            "subject": "Contact Form",
            "html": `Hi<br><br>Contact Email: ${contactForm.email}, About: ${contactForm.about}, Message: ${contactForm.msg}<br><br>` + JSON.stringify(contactForm)
          }
        })
    },
    updateUserOnboarding(_, { userId, update }) {
        firebase.firestore().doc(`users/${userId}`).update(update)
        
        firebase.firestore().collection(`emails`).add({
          "to": ["hi@metatext.io"],
          "message": {
            "subject":  `User onboarding - ${firebase.auth().currentUser.email} from ${update.infoProfile.company}`,
            "html": `Hi<br>User email: ${firebase.auth().currentUser.email}<br>Profile: ${update.infoProfile.role}<br>Industry: ${update.infoProfile.industry}<br>What are looking for: ${update.infoProfile.how}<br>Attend to workshop? ${update.infoProfile.workshop}<br><br><br><br>><br>UserId: ${firebase.auth().currentUser.uid}<br>JSON: ` + JSON.stringify(update)
          }
        })
    },
    inviteMember(_, { userId, userName, memberEmail }) {
  
        firebase.firestore().collection(`emails`).add({
          "to": [memberEmail],
          "message": {
            "subject":  `You're Invited to Join Metatext.AI`,
            "html": `Hello!<br>We are excited to extend an invitation to you on behalf of ${userName} to join Metatext.AI. This invitation provides you with access to collaborate on ${userName}'s AI projects.
            <br><br>
            <b>Inviter's Name:</b>
            <br>
            ${userName}
            <br><br>
            <b>Invitation Link:</b>
            <br>
            https://app.metatext.ai/signup?invite=${userId}
            <br>
            If you have any questions or need assistance, please don't hesitate to reach out to us at [Support Email Address]. We look forward to having you on board and witnessing the innovative outcomes of our collective efforts.
            <br><br>
            Best regards,
            Metatext Team`
          }
        })


    },
    updateMembers(_, { organizationId, members }) {
        firebase.firestore().doc(`users/${organizationId}`).update({
            "members": members
        })
    },
    updateOrganization(_, { organizationId, organization }) {
        firebase.firestore().doc(`users/${organizationId}`).update({
            "organization": organization
        })
    },
    checkoutParams(_, { userId, checkoutParams }) {
        firebase.firestore().doc(`users/${userId}`).update({
            "checkoutParams": checkoutParams
        })
    },
    currentUser: firestoreAction(({ bindFirestoreRef }) => {
        
        const userId = (firebase.auth().currentUser)?firebase.auth().currentUser.uid:undefined
        
        return bindFirestoreRef('currentUser', firebase.firestore().doc(`users/${userId}`), {wait: true})
    }),
    currentOrg: firestoreAction(({ bindFirestoreRef }, organizationId) => {
        
        return bindFirestoreRef('currentOrg', firebase.firestore().doc(`users/${organizationId}`), {wait: true})
    }),
    usage: firestoreAction(({ bindFirestoreRef }, organizationId) => {
        return bindFirestoreRef('usage', 
            firebase.firestore().collection(`users/${organizationId}/usage`)
            .orderBy("createdAt", "desc")
          )
    }),
    promoCodes: firestoreAction(({ bindFirestoreRef }) => {
        return bindFirestoreRef('promoCodes', 
            firebase.firestore().collection(`codes`)
            .where("applied", '!=', true)
          )
    }),
    validateCode: async ({ dispatch, commit }, promoCodeId) => {
        
        try {
          const doc = await firebase.firestore().collection(`codes`).doc(`${promoCodeId}`).get();
          const result = doc.data();
          if (!doc.exists) return false
          else return !result.applied
        } catch (error) {
          console.error("Error verifying promo code:", error);
          throw error; // Re-throw the error if needed
        }
    },
    applyPromoCode: (_, {userId, promoCodeId}) => {
        
        return (
            firebase.firestore().collection(`codes`).doc(`${promoCodeId}`).update({
                applied: true,
                userId: userId,
                applied_at: firebase.auth().currentUser.metadata.creationTime
            })
        )
    },
    getUser: firestoreAction(({ bindFirestoreRef }, userId) => {

        return bindFirestoreRef('getUser', firebase.firestore().doc(`users/${userId}`))
    }),
    /** ADMIN */
    retrieveAllUsersAdmin: firestoreAction(({ bindFirestoreRef, state }) => {
        if (state.users) {
            return
        }
        return bindFirestoreRef('users', firebase.firestore().collection(`users`).orderBy('createdAt', 'desc'))
    }),
}

export default actions